import { createApiHook } from '../hooks';
import { appEventsApiFactory } from './appEventsApiFactory';

export const useAppEventsApi = createApiHook(appEventsApiFactory);
